import { gql } from '@apollo/client';

export const GetGroupForEdit = gql`
  query GetGroupForEdit($id: ID!) {
    id
    group(id: $id) {
      id
      name
      users {
        id
        name
      }
      roles {
        id
        name
      }
      boards {
        id
        name
      }
    }
  }
`;
